import React, { useEffect, useState } from "react";
import { Link, Route, useParams, useRouteMatch } from "react-router-dom";

import {
	Row,
	Divider,
	Typography,
	Tag,
	Menu,
	Icon,
	Breadcrumb,
	Button,
	Col,
	Dropdown,
	Input,
	message,
	Modal,
	Table,
	Upload,
	Select,
	Tooltip,
	Switch,
} from "antd";
import Loader from "components/Loader/Loader";

import emptyImageFeatureDetails from "./images/emptyImageFeatureDetails.png";
import { countries } from "constants/CountryList";

import { ReactComponent as InfoLogo } from "./images/info-circle.svg";
import "./rollout.scss";
import { fetchCohortAdminListApi, fetchFeatureListApi, updateFeatureListApi } from "utils/apiService";
const { Text } = Typography;
const { Option } = Select;
const AddChort = (props) => {
	const { addModal, setAddModal } = props;
	const { cohorts } = props;

	const [addedCohorts, setAddedCohorts] = useState(
		props.feature.cohorts.map((item) => {
			return item.uuid;
		})
	);
	return (
		<Modal centered visible={addModal} destroyOnClose maskClosable={false} onCancel={() => setAddModal(false)} footer={null}>
			<Row className="modal-row">
				<Row>
					<Icon
						type="cluster"
						style={{
							background: "#E5F3FF",
							color: "#1890FF",
							fontSize: "24px",
							marginRight: "16px",
						}}
					/>
					<Text
						style={{
							fontWeight: "bold",
							color: "#181818",
							fontSize: "24px",
						}}>
						Add a New Cohort
					</Text>
				</Row>
				<Row
					style={{
						height: "1px",
						background: "#E8E8E8",
						marginTop: "16px",
					}}></Row>
				<Row style={{ marginTop: "24px" }}>
					<div>
						<div style={{}}>
							<Text
								style={{
									fontSize: "14px",
									color: "#181818",
									fontWeight: "bold",
									// fontWeight:"bold"
								}}>
								Select Cohort
							</Text>
							<Select
								mode="tags"
								className="time-value-cohort-col-main-element"
								style={{ width: "100%", marginTop: "8px" }}
								placeholder="Select Cohorts"
								tokenSeparators={[",", " "]}
								defaultValue={addedCohorts}
								onChange={(e) => {
									setAddedCohorts(e);
								}}>
								{cohorts.map((cohort) => {
									return (
										<Option value={cohort.uuid} key={cohort.uuid} label={cohort.name}>
											{cohort.name}
										</Option>
									);
								})}
							</Select>
						</div>
					</div>
					<Row
						type="flex"
						justify="end"
						align="middle"
						style={{
							marginTop: "40px",
						}}>
						<Button
							size="large"
							style={{
								height: "40px",
								boxShadow: "none",
								borderRadius: "20px",
								border: "none",
								backgroundColor: "#FFFFFF",
								color: "#181818",
								marginRight: "12px",
							}}
							onClick={() => setAddModal(false)}>
							Cancel
						</Button>
						<Button
							size="large"
							style={{
								height: "40px",
								borderRadius: "2px",
								border: "none",
								backgroundColor: "#fec708",
								color: "#FFFFFF",
							}}
							onClick={() => {
								let data = {};
								data[props.feature.name] = { cohorts: addedCohorts };
								updateFeatureListApi({
									requestData: data,
									resCallback: () => {
										// loading && setLoading(false);
										// setTableLoading(false);
									},
									res200Callback: async (res) => {
										await props.loadData();
										setAddModal(false);
										message.success("Cohorts Added Successfully");

										// props.setReload(true);
									},
									// resErrorCallback:()=>{

									// }
								});
							}}>
							Add Cohort
						</Button>
					</Row>
				</Row>
			</Row>
		</Modal>
	);
};
const CohortsTable = (props) => {
	const { data } = props;

	const [removeModal, setRemoveModal] = useState(false);
	const [removeCohort, setRemoveCohort] = useState("");
	const columns = [
		{
			title: "Cohort Name",
			dataIndex: "name",
			key: "cohortName",
			render: (data) => {
				return (
					<Text
						style={{
							fontStyle: "normal",
							fontWeight: "bold",
							fontSize: "16px",
							lineHeight: "24px",
							color: "#181818",
							whiteSpace: "nowrap",
						}}>
						{data ? data : "-"}
					</Text>
				);
			},
		},
		{
			title: "No. of Customers",
			dataIndex: "user_count",
			key: "customerCount",
			render: (data) => {
				return (
					<Text
						style={{
							fontStyle: "normal",
							fontWeight: "bold",
							fontSize: "16px",
							lineHeight: "24px",
							color: "#181818",
							whiteSpace: "nowrap",
						}}>
						{data}
					</Text>
				);
			},
		},
		{
			title: "Added On",
			dataIndex: "date_added",
			key: "addedOn",
			render: (data) => {
				return (
					<Text
						style={{
							fontStyle: "normal",
							//   fontWeight: "bold",
							fontSize: "16px",
							lineHeight: "24px",
							color: "#747474",
							whiteSpace: "nowrap",
						}}>
						{data ? data : "10 Nov 2021"}
					</Text>
				);
			},
		},
		{
			title: "",
			dataIndex: ["uuid", "name"],
			key: "uuid",
			render: (_, row) => {
				return (
					<div style={{ width: "16px" }}>
						<Dropdown
							placement={"bottomLeft"}
							onClick={(e) => {
								e.stopPropagation();
							}}
							style={{ marginLeft: "0" }}
							overlay={
								<Menu>
									<Menu.Item
										onClick={(e) => {
											e.domEvent.stopPropagation();
											setRemoveCohort(row.uuid);
											setRemoveModal(true);
										}}>
										<Text style={{ color: "#F5222D" }}>Remove</Text>
									</Menu.Item>
								</Menu>
							}>
							<Icon
								type="more"
								onClick={(e) => {
									e.stopPropagation();
								}}
								style={{
									fontSize: "16px",
									color: "#747474",
									marginLeft: "52px",
								}}
							/>
						</Dropdown>
					</div>
				);
			},
		},
	];

	return (
		<>
			<Table
				columns={(function () {
					return columns;
				})()}
				dataSource={data}
				pagination={{ showQuickJumper: true, pageSize: 10 }}
				style={{ overflow: "none" }}
				onChange={(pagination) => {
					props.updatePage(pagination.current);
				}}
				loading={props.loading}
			/>

			<Modal centered visible={removeModal} destroyOnClose maskClosable={false} onCancel={() => setRemoveModal(false)} footer={null}>
				<Row className="modal-row">
					<Row>
						<Icon
							type="remove"
							style={{
								color: "#181818",
								fontSize: "24px",
								// marginRight: "16px",
							}}
						/>
						<Text
							style={{
								fontWeight: "bold",
								color: "#181818",
								fontSize: "24px",
							}}>
							Remove Cohort
						</Text>
					</Row>
					<Row style={{ marginTop: "24px" }}>
						<Col span={24}>
							<Text>Are you sure you want to remove this Cohort?</Text>
						</Col>
						<Col
							style={{
								marginTop: "60px",
								textAlign: "right",
							}}
							span={18}>
							<Button
								size="large"
								style={{
									height: "40px",
									boxShadow: "none",
									borderRadius: "20px",
									border: "none",
									backgroundColor: "#FFFFFF",
									color: "#181818",
								}}
								onClick={() => setRemoveModal(false)}>
								Cancel
							</Button>
						</Col>
						<Col
							style={{
								marginTop: "60px",
								textAlign: "right",
							}}
							span={6}>
							<Button
								size="large"
								style={{
									height: "40px",
									borderRadius: "2px",
									border: "none",
									backgroundColor: "#C91713",
									color: "#FFFFFF",
								}}
								onClick={() => {
									let updatedCohort = props.feature.cohorts
										.filter((cohort) => {
											return cohort.uuid != removeCohort;
										})
										.map((cohort) => {
											return cohort.uuid;
										});
									let data = {};
									data[props.feature.name] = { cohorts: updatedCohort };
									updateFeatureListApi({
										requestData: data,
										resCallback: () => {
											// loading && setLoading(false);
											// setTableLoading(false);
										},
										res200Callback: (res) => {
											setRemoveModal(false);
											message.success("Cohort removed Successfully");
											props.setReload(true);
										},
										// resErrorCallback:()=>{

										// }
									});
								}}>
								Remove
							</Button>
						</Col>
					</Row>
				</Row>
			</Modal>
		</>
	);
};
const FeatureDetails = (props) => {
	const { featureId } = props.match.params;
	const [feature, setFeature] = useState({});
	const [loading, setLoading] = useState(true);
	const [addModal, setAddModal] = useState(false);
	const [cohorts, setCohorts] = useState([]);
	const [reload, setReload] = useState(false);
	// console.log(featureId);
	const loadData = () => {
		fetchFeatureListApi({
			requestData: {},
			resCallback: () => {},
			res200Callback: (res) => {
				let tempFeature = Object.keys(res.data).map((key) => {
					const currfeature = res.data[key];
					if (currfeature.uuid == featureId) {
						const date = new Date(currfeature.date_created * 1000);
						setFeature({ ...currfeature, name: key, date_created: date.toLocaleDateString() });
					}
				});
				setLoading(false);
				setReload(false);
			},
		});
	};
	useEffect(() => {
		fetchCohortAdminListApi({
			requestData: {
				// status: activeTab === "archived" ? "archived" : "active",
			},
			resCallback: () => {
				// setLoading(false);
				// setTableLoading(false);
			},
			res200Callback: (res) => {
				setCohorts(res.data.cohort_list);
			},
		});
		loadData();
	}, [reload]);
	return (
		<Row
			style={{
				width: "100%",
				padding: "40px 25px 70px",
				margin: "60px auto 20px",
				backgroundColor: "#FAFAFA",
			}}
			gutter={[12, 48]}>
			{loading ? (
				<Row type="flex" align="middle" justify="center" style={{ marginTop: "200px" }}>
					<Loader />
				</Row>
			) : (
				<>
					<Row type="flex" align="middle">
						<Text
							style={{
								color: "#181818",
								/*fontFamily: "Gotham",*/ fontStyle: "normal",
								fontWeight: "bold",
								fontSize: "24px",
								lineHeight: "39px",
							}}>
							{"Feature Details"}
						</Text>
					</Row>
					<Breadcrumb style={{ margin: "12px 0 24px" }} separator={<span style={{ color: "#747474" }}>{"<"}</span>}>
						<Breadcrumb.Item
							style={{
								/*fontFamily: "Gotham",*/ fontStyle: "normal",
								fontWeight: "normal",
								fontSize: "14px",
								lineHeight: "22px",
								color: "#747474",
							}}>
							<Link to="/rollout">Rollout Features</Link>
						</Breadcrumb.Item>
						<Breadcrumb.Item
							style={{
								/*fontFamily: "Gotham",*/ fontStyle: "normal",
								fontWeight: "normal",
								fontSize: "14px",
								lineHeight: "22px",
								color: "#464646",
							}}>
							{feature.name}
						</Breadcrumb.Item>
					</Breadcrumb>
					<div
						style={{
							background: "#FFFFFF",
							padding: "16px",
							border: "1px solid #F2F2F2",
							boxSizing: "border-box",
							borderRadius: "8px",

							display: "flex",
							width: "100%",
							justifyContent: "space-between",
							alignItems: "center",
							fontWeight: "400",
							fontSize: "14px",
							lineHeight: "22px",
							color: "#747474",
						}}>
						<div style={{ display: "flex", flexDirection: "column" }}>
							<Text>Feature Details</Text>
							<Text
								style={{
									color: "#181818",
									fontSize: "16px",
									lineHeight: "24px",
									marginTop: "4px",
									fontWeight: "bold",
								}}>
								{feature.name}
								<Tooltip
									placement="bottomRight"
									title={
										<span
											style={{
												color: "white",
											}}>
											{feature.description ? feature.description : "Add description"}
										</span>
									}>
									<InfoLogo
										style={{
											marginLeft: "5px",
											marginTop: "4px",
										}}
									/>
								</Tooltip>
							</Text>
						</div>
						<div style={{ display: "flex", flexDirection: "column" }}>
							<Text>Connection</Text>
							<Tag
								className={feature.is_enabled ? "connectedTag" : "notConnectedTag"}
								style={{
									width: "auto",
									padding: "2px 8px",
									marginTop: "4px",
								}}>
								<Text
									style={{
										fontSize: "12px",
										lineHeight: "20px",
										color: `${feature.is_enabled ? "#2A9C0A" : "#CD0005"}`,
									}}>
									{feature.is_enabled ? "Enabled" : "Disabled"}
								</Text>
							</Tag>
						</div>
						<div style={{ display: "flex", flexDirection: "column" }}>
							<Text>Total User</Text>
							<Text
								style={{
									color: "#181818",
									fontSize: "16px",
									lineHeight: "24px",
									marginTop: "4px",
									fontWeight: "bold",
								}}>
								{feature.user_count || "-"}
							</Text>
						</div>
						<div style={{ display: "flex", flexDirection: "column" }}>
							<Text>Created on</Text>
							<Text
								style={{
									color: "#181818",
									fontSize: "16px",
									lineHeight: "24px",
									marginTop: "4px",
									fontWeight: "bold",
								}}>
								{feature.date_created || "-"}
							</Text>
						</div>
						<div style={{ display: "flex", flexDirection: "column" }}>
							<Text>Status</Text>
							<Text
								style={{
									color: "#181818",
									fontSize: "16px",
									lineHeight: "24px",
									marginTop: "4px",
									fontWeight: "bold",
								}}>
								<Switch
									defaultChecked={feature.is_enabled}
									onChange={(value) => {
										let data = {};
										data[feature.name] = { is_enabled: value };
										updateFeatureListApi({
											requestData: {
												countryId: JSON.parse(localStorage.getItem("countryData"))?.database_identifier,
												...data,
											},
											res200Callback: (res) => {
												message.success("Feature updated successfully");
											},
											resErrorCallback: (res) => {
												message.error("Feature update failed");
											},
										});
									}}
								/>
							</Text>
						</div>
					</div>
					{feature.cohorts && feature.cohorts.length === 0 ? (
						<>
							<Row>
								<div
									style={{
										display: "flex",
										flexDirection: "column",
										justifyContent: "center",
										alignItems: "center",
										backgroundColor: "#FAFAFA",
										marginTop: 50,
									}}>
									<img src={emptyImageFeatureDetails} alt="Illustration for empty cohort list" />
									<Text
										style={{
											fontSize: "20px",
											color: "#181818",
											fontWeight: "bold",
											marginTop: "16px",
										}}>
										You have not added any cohorts yet.
									</Text>
									<Text
										style={{
											color: "#747474",
											marginTop: "8px",
											textAlign: "center",
										}}>
										Click on Add cohort to add new cohort
									</Text>
									<Button
										onClick={() => {
											setAddModal(true);
										}}
										style={{
											display: "flex",
											alignItems: "center",
											padding: "8px 16px",
											color: "#FFFFFF",
											fontSize: "16px",
											lineHeight: "24px",
											background: "#fec708",
											borderRadius: "5px",
											height: "100%",
											margin: "0 0 0 12px",
											marginTop: "24px",
										}}>
										<Icon
											type="plus"
											style={{
												height: "16px",
											}}
										/>
										Add Cohort
									</Button>
								</div>
							</Row>
						</>
					) : (
						<>
							<Row style={{ display: "flex", justifyContent: "space-between" }}>
								<Row
									style={{
										width: "100%",
										padding: "40px 0px 0px 0px",
									}}>
									<Text
										style={{
											color: "#181818",
											/*fontFamily: "Gotham",*/ fontStyle: "normal",
											fontWeight: "bold",
											fontSize: "18px",
											lineHeight: "24px",
											marginTop: "50px",
											//   width: "100%",
										}}>
										{"Cohort Details"}
									</Text>
								</Row>
								<Button
									onClick={() => {
										setAddModal(true);
									}}
									style={{
										display: "flex",
										alignItems: "center",
										padding: "8px 16px",
										color: "#FFFFFF",
										fontSize: "16px",
										lineHeight: "24px",
										background: "#fec708",
										borderRadius: "5px",
										height: "100%",

										marginTop: "32px",
									}}>
									<Icon
										type="plus"
										style={{
											height: "16px",
										}}
									/>
									Add Cohort
								</Button>
							</Row>
							<Row
								style={{
									marginTop: "16px",
								}}>
								<CohortsTable data={feature.cohorts} feature={feature} setReload={setReload}></CohortsTable>
							</Row>
						</>
					)}
				</>
			)}

			{!loading && (
				<AddChort addModal={addModal} setAddModal={setAddModal} cohorts={cohorts} feature={feature} setReload={setReload} loadData={loadData} />
			)}
		</Row>
	);
};
export default FeatureDetails;
